

(function ($) {

    $(window).on('load', function () {

        var theWindow = $(window),
            $bg = $("#bg"),
            aspectRatio = $bg.width() / $bg.height();
        theWindow.resize(function () {
            resizeBg($bg, theWindow, aspectRatio);
        }).trigger("resize");

    });

    // lazysizes background image.

    document.addEventListener('lazybeforeunveil', function(e){
        var bg = e.target.getAttribute('data-bg');
        if(bg){
            e.target.style.backgroundImage = 'url(' + bg + ')';
        }
    });

  

    function checkCookies() {

        var popup_accepted = getCookie("cookies_accepted");
        if (popup_accepted != 1) {
            $('#cookieDisclaimer').removeClass('remove');
            $('#cookieDisclaimer').addClass('is-visible');
        } else {
            $('#cookieDisclaimer').removeClass('is-visible');
        }
    }


    function cookieDisclaimer() {

        // Click event
        $('.remove-cookie-disclaimer').click(function () {
            setCookie("cookies_accepted", '1', 365);
            $('#cookieDisclaimer').addClass('remove');
        });

        // Do the check
        checkCookies();
    };


    // Survey
    function surveyModal() {

        // Do the check
        var surveyShown = getCookie('survey_shown');
        if (surveyShown != 1) {
            $('#surveyModal').modal('show');
        }

        // Click event
        $('.modal-survey .btn').click(function () {
           setCookie('survey_shown', '1', 365);
            $('#surveyModal').modal('hide');
        });

    };


    $(document).ready(function () {
        
       
        
        $("a#respond-cancel").click(function (e) {
            e.preventDefault();
            $("#form-holder #respond_to").css("display", "none");
            $("form#commentform input[name=comment_parent]").val("");
            $("form#commentform input[name=comment_reply_hash]").val("");
            $("#form-holder input#email").off('keyup');
            $("form#commentform").off('submit');
        });

        $("a.js-answer-comment").click(function () {
            var data = {
                comment_parent_id: $(this).attr("alt"),
                comment_id: $(this).parent().find("input#comment-id").val(),
                reply_hash: $(this).parent().find("input#reply-hash").val(),
                email_hash: md5($("form#commentform input#email").val()),
                name: $(this).parent().parent().find("span#inner_name").html()
            }
            console.log('comment',data);


            $("a#respond-cancel").attr("href", "#comment-" + data.comment_id);
            $("#form-holder #respond_to span#respond_to_name").html(data.name);
            $("#form-holder #respond_to").css("display", "inline-block");
            $("form#commentform input[name=comment_parent]").val(data.comment_parent_id);
            $("form#commentform input[name=comment_reply_hash]").val(data.reply_hash);
        });

        // Remove empty sidebar containers
        // TODO: Update with new classnames etc
        $('.right-sidebar .check-content').each(function (i, el) {
            var parent_el = $(el).closest('.whitebox');
            var widget_content = $(el).find('.textwidget');
            var content = $(el).html();
            if (widget_content.length) {
                content = widget_content.html();
            }
            content = $.trim(content);
            if (content === '') {
                parent_el.remove();
            }
        });

        // Toggles comments on/off
        $('.js-toggle-comments').on('click', function (e) {
            e.preventDefault();
            $(this).toggleClass('is-open');
            $('.toggle-comments__show').toggleClass('hidden');
            $('.toggle-comments__hide').toggleClass('show');
            $('.maincard--comments').toggleClass('is-visible');
        })


        // Initiate Fancybox on all images in content
        $('.the-content img').not('.wrap_svl_center img').each(function () {
            var $img = $(this);
            var href = $img.attr('src');
            $img.wrap('<a data-fancybox="gallery" class="post__fancybox-link" href="' + href + '"></a>');
        });

        // Remove fancybox, put click event on .product div
        var productLinks = $('.products div.product');
        $.each(productLinks, function(index) {

            var target = $(productLinks[index]);
            var link = target.find('.product__title a').attr('href');
            
            // keep the image, remove the link
            var img = target.find('.product__image img');
            target.find('.product__image').html(img);            
            target.data('href', link).addClass('product--is-link').attr("tabindex","0");

            // remove link from title
            var title = target.find('.product__title a').text();
            target.find('.product__title').text(title);


        });

        $('.products div.product').on('click', function(e) {
            var href = $(this).data('href');
            window.open(href);
        });

        // // Wrap all iframes (YouTube videoes) in .video-container - ONLY use if FVE plugin is disabled
        $('.the-content iframe').each( function() {
        	var $iframe = $(this);
        	$iframe.wrap('<div class="video-container"></div>');
        });


        // TODO: Remove this if VIDEO ID (below) can be used
        // Start hero-video onClick on overlay, then remove overlay
        // $('.js-play-hero-video').on('click', function(ev) {
        // 	$(this).toggleClass('is-hidden');
        // 	$("#hero-video")[0].src += "&autoplay=1";
        // 	ev.preventDefault();
        // });

        //Start hero-video onClick on overlay, then remove overlay


        // Back to top$(document).ready(function() {
        $(window).scroll(function () {
            if ($(this).scrollTop() > 200) {
                $('.js-go-to-top').fadeIn(200);
            } else {
                $('.js-go-to-top').fadeOut(200);
            }
        });

        // Animate the scroll to top
        $('.js-go-to-top').click(function (event) {
            event.preventDefault();

            $('html, body').animate({scrollTop: 0}, 300);
        })


		// Hero video
        var player;
        if (jQuery('#hero-video').length) {
            var videoID = document.getElementById("hero-video").getAttribute("data-id");
        }
        function initialize() {}

    });

    // TODO: Remove if new fancybox works
    // Initiate fancybox on all images in content
    // $.fn.fancyInit = function()
    // {
    //     var obj = $(this);
    //     var content_images = obj.find('.the-content img');
    //     //var content_images = obj.find('.maincard img');
    //     content_images.each(function(i, el){
    //         var img_obj = $(el);
    //         var parent_el = img_obj.parent();
    //         var image_src = img_obj.attr('src');
    //         var parent_tagname = parent_el.prop("tagName");
    //         if(parent_tagname.toLowerCase() !== 'a')
    //         {
    //             img_obj.wrap('<a href="' + image_src + '" rel="gallery_1"></a>');
    //             parent_el = img_obj.parent();
    //         }
    //         else
    //         {
    //             parent_el.attr('rel', 'gallery_1');
    //         }
    //         parent_el.fancybox();
    //     });
    //     obj.find('a[rel="gallery_1"]').fancybox({
    //         'loop' : false
    //     });
    // };

    // TODO: Remove if FLEX works
    // Make all elements the same height - Replaced by Flex
    // $.fn.makesameheight = function(){
    //     $('.makesameheight .white-box-inner').removeAttr('style');
    //     $.each($('.makesameheight'),function(i,el){
    //         var $highest = 0;
    //         var $row_elements = $(el).find('.white-box-inner');
    //         $.each($row_elements,function(j,inner){
    //             $highest = ($highest>$(inner).height()?$highest:$(inner).height());
    //         });
    //         if($(window).width() > 750)
    //             $($row_elements).height($highest);
    //         else
    //             $($row_elements).removeAttr('style');
    //     });
    // };

    $.fn.check_reply_hash = function (email_hash, reply_hash) {
        if (email_hash == reply_hash) {
            $("form#commentform input#email").css("color", "green");
            return true;
        }
        else {
            $("form#commentform input#email").css("color", "red");
            return false;
        }
    };
    // Check Cookie
    cookieDisclaimer();

    // Survey modal -> Comment back in if you want to use the survey modal, modal itself is in footer.php
    // surveyModal(); 


    // SLICK SLIDER

    $('.slider-equal-height').slick({
		slidesToShow: 1, 
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
	});

})(jQuery);

function resizeBg($bg, theWindow, aspectRatio) {
    if ((theWindow.width() / theWindow.height()) < aspectRatio)
        $bg.removeClass().addClass('bgheight');
    else
        $bg.removeClass().addClass('bgwidth');
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
}

// Cookie functions
function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/"
}

